// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file inventory/v1/assessment_report_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import { AssessmentReportService } from "./assessment_report_service_pb";

/**
 * @generated from rpc inventory.v1.AssessmentReportService.GenerateReport
 */
export const generateReport = AssessmentReportService.method.generateReport;

/**
 * @generated from rpc inventory.v1.AssessmentReportService.GetAssessmentReportTemplates
 */
export const getAssessmentReportTemplates = AssessmentReportService.method.getAssessmentReportTemplates;

/**
 * @generated from rpc inventory.v1.AssessmentReportService.SetAssessmentReportTemplate
 */
export const setAssessmentReportTemplate = AssessmentReportService.method.setAssessmentReportTemplate;

/**
 * @generated from rpc inventory.v1.AssessmentReportService.UpdateAssessmentReportTemplate
 */
export const updateAssessmentReportTemplate = AssessmentReportService.method.updateAssessmentReportTemplate;

/**
 * @generated from rpc inventory.v1.AssessmentReportService.ResetAssessmentReportTemplateToDefault
 */
export const resetAssessmentReportTemplateToDefault = AssessmentReportService.method.resetAssessmentReportTemplateToDefault;

/**
 * @generated from rpc inventory.v1.AssessmentReportService.UpdateAssessmentReport
 */
export const updateAssessmentReport = AssessmentReportService.method.updateAssessmentReport;

/**
 * @generated from rpc inventory.v1.AssessmentReportService.DeleteAssessmentReport
 */
export const deleteAssessmentReport = AssessmentReportService.method.deleteAssessmentReport;

/**
 * @generated from rpc inventory.v1.AssessmentReportService.ListAssessmentReports
 */
export const listAssessmentReports = AssessmentReportService.method.listAssessmentReports;
